import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Button, Modal, message, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

import { quoteDetails, acceptOrDenyQuote } from './graphql';
import history from '../../config/history';
import QuoteDetailTable from '../../components/grids/QuoteDetailTable';
import Loading from '../../components/Loading';

const { Panel } = Collapse;

export default class ViewQuote extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
  };
  state = {
    details: [],
    status: '',
    loading: false,
  };
  async componentDidMount() {
    this.setState({ loading: true });
    console.log(this.props.location);
    const urlParams = new URLSearchParams(this.props.location.search);
    console.log(urlParams);

    const quoteId = urlParams.get('quote');
    const rfqId = urlParams.get('rfq');

    if (!quoteId || !rfqId) {
      message
        .error(
          'Oops, We Cannot Find this RFQ, Please Contact Support if Problem Persists',
          2.5,
        )
        .then(() => {
          history.goBack();
        });
    } else {
      const res = await quoteDetails(this.props.auth.id, rfqId, quoteId);
      if (res.quoteDetails.quote.unauthorized) {
        message
          .error(
            'Your Company does not have Permission to view this Quote',
            2.5,
          )
          .then(() => {
            history.goBack();
          });
      }
      let status = res.quoteDetails.quote.status;
      if (status === 'Submitted') {
        status = 'Ready For Review';
      }
      this.setState({ status });
      const details = this.formatQuote(res.quoteDetails.quote);
      console.log(details);
      this.setState({ details, loading: false });
    }

    // this.setState({ loading: true });
  }

  acceptOrDenyQuote = async status => {
    const urlParams = new URLSearchParams(this.props.location.search);
    console.log(urlParams);

    const quoteId = urlParams.get('quote');
    const rfqId = urlParams.get('rfq');

    const res = await acceptOrDenyQuote(
      this.props.auth.id,
      rfqId,
      quoteId,
      status,
    );
    const resStatus = res.handleQuoteAcceptance.status;
    const resMessage = res.handleQuoteAcceptance.msg;
    if (resStatus === 'failure') {
      if (
        resMessage.includes('RFQ and Quotes status is already in Awarded state')
      ) {
        message.error('This Quote Has Already been awarded', 2.5).then(() => {
          history.goBack();
        });
      } else {
        message.error(
          'Oops, Something Went Wrong While Saving the Quote, Please Try Again and If Problem Persists Contact Support',
        );
      }
    } else {
      const displayStatus = status === 'accept' ? 'Awarded' : 'Declined';
      message.success(`Quote successfully ${displayStatus}`, 2.5).then(() => {
        history.goBack();
      });
    }
  };

  confirmQuoteAccept = () => {
    Modal.confirm({
      title: 'Accept this Quote?',
      icon: <CheckCircleOutlined style={{ color: '#2ebd38' }} />,
      content:
        'This will Accept the Quote and Notify the sender of the decision',
      okText: 'Confirm',
      onOk: () => {
        this.acceptOrDenyQuote('accept');
      },

      cancelText: 'Cancel',
    });
  };

  confirmQuoteDeny = () => {
    Modal.confirm({
      title: 'Deny this Quote?',
      icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
      content:
        'This will Deny the Quote and Notify the Sender of Your Decision ',
      okText: 'Confirm',
      onOk: () => {
        this.acceptOrDenyQuote('decline');
      },

      cancelText: 'Cancel',
    });
  };

  formatQuote = quote => {
    const formattedOBJ = {
      unitPrice: 'Unit Price',
      shipping: 'Shipping Cost',
      toolingDesc: 'Tooling Description',
      toolingAvailable: 'Tooling Available',
      sampleAvailable: 'Sample Available',
      machiningReq: 'Machining Required',
      ndaAccept: 'NDA Acceptance',
      qty: 'Quantity',
      totalCost: 'Total Cost',
      comment: 'Comments ',
      companyName: 'Company Name',
      deliveryDate: 'Delivery Date',
    };
    const formattedArray = [];
    delete quote.status;

    // eslint-disable-next-line
    for (const [key, value] of Object.entries(quote)) {
      console.log(`${key}: ${value}`);

      const formattedKey = formattedOBJ[key];
      if (!formattedKey) {
        console.log('missing Key', key);
      } else if (
        key === 'ndaAccept' ||
        key === 'sampleAvailable' ||
        key === 'machiningReq'
      ) {
        if (value === '1') {
          formattedArray.push({ key: formattedKey, value: 'Yes' });
        } else {
          formattedArray.push({ key: formattedKey, value: 'No' });
        }
      } else if (!value) {
        formattedArray.push({ key: formattedKey, value: '-' });
      } else {
        formattedArray.push({ key: formattedKey, value });
      }
    }
    return formattedArray;
  };

  onErrorClose = () => {
    history.goBack();
  };

  render() {
    const { details, status, loading } = this.state;
    return (
      <div>
        {' '}
        {loading && <Loading />}
        {!loading && (
          <div className="edit-contract-wrapper">
            <Collapse defaultActiveKey={['1']}>
              <Panel
                header={
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {' '}
                    <div> RFQ Details </div>{' '}
                    <div>
                      Status:{' '}
                      <Tag
                        color={
                          status === 'Declined'
                            ? 'red'
                            : status === 'Awarded'
                              ? 'green'
                              : ''
                        }
                      >
                        {status}
                      </Tag>
                    </div>{' '}
                  </div>
                }
                key="1"
              >
                <h1>Quote Details</h1>
                <QuoteDetailTable quoteDetails={details} />
                <div className="quote-button-wrapper">
                  <Button
                    onClick={() => {
                      history.goBack();
                    }}
                    type="primary"
                    style={{
                      background: '#ff7c52',
                      color: 'white',
                      borderColor: '#ff7c52',
                    }}
                  >
                    Close
                  </Button>
                  {(status !== 'Declined' || status === 'Awarded') && (
                    <Button
                      type="primary"
                      danger
                      onClick={this.confirmQuoteDeny}
                    >
                      Deny Quote
                    </Button>
                  )}

                  {status !== 'Awarded' &&
                    status !== 'Declined' && (
                      <Button
                        style={{
                          background: '#2ebd38',
                          color: 'white',
                          borderColor: '#2ebd38',
                        }}
                        onClick={this.confirmQuoteAccept}
                      >
                        Award Quote
                      </Button>
                    )}
                </div>
              </Panel>
            </Collapse>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ViewQuote/ViewQuote.jsx